export function convertRadiansToDegrees(radians) {
  return radians * 180 / Math.PI;
}

export function convertDegreesToRadians(degrees) {
  return degrees * Math.PI / 180;
}

export function convertCartesianToSpherical(x, y, z) {
  const rho = Math.sqrt(x ** 2 + y ** 2 + z ** 2);
  const phi = Math.atan2(x, y);
  const theta = Math.acos(z / rho);
  return {
    rho,
    phi: convertRadiansToDegrees(phi),
    theta: convertRadiansToDegrees(theta),
  };
}



// WEBPACK FOOTER //
// ./src/helpers/coordinates.js